import axios from 'axios';
import { SessionManager } from './sessionManager';

// Axios authentication setup
export const setupAxiosAuth = (token, username) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
  if (username) {
    axios.defaults.headers.common['X-Username'] = username;
  }
  console.log('✅ Axios authentication headers set for user:', username);
};

export const restoreAxiosAuth = (userData) => {
  if (userData?.token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${userData.token}`;
  }
  if (userData?.UserName) {
    axios.defaults.headers.common['X-Username'] = userData.UserName;
  }
};

export const clearAxiosAuth = () => {
  delete axios.defaults.headers.common['Authorization'];
  delete axios.defaults.headers.common['X-Username'];
  console.log('🔄 Axios auth headers cleared');
};

// User management
export const getCurrentUser = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    // console.log('Current user❤️❤️❤️❤️❤️❤️:', userData);
    return userData.UserName || userData.username || 'System';
  } catch (error) {
    console.error('Error getting current user:', error);
    return 'System';
  }
};

export const getUserData = () => {
  return SessionManager.getUserSession();
};

export const setUserData = (userData) => {
  SessionManager.setUserSession(userData);
};

export const clearUserData = () => {
  SessionManager.clearSession();
};

// Authentication status
export const isAuthenticated = () => {
  const userData = SessionManager.getUserSession();
  return !!userData && !!userData.token;
};

export const isSessionValid = () => {
  return SessionManager.getUserSession() !== null;
};

// Session management
export const getSessionData = () => {
  const userData = SessionManager.getUserSession();
  return {
    user: userData?.UserName || userData?.username,
    userData: userData,
    token: userData?.token,
    isAuthenticated: isAuthenticated(),
    location: userData?.UserLocation
  };
};

export const isSessionNearExpiry = () => {
  return SessionManager.isNearExpiry();
};

export const getTimeUntilExpiry = () => {
  return SessionManager.getTimeUntilExpiry();
};

export const extendSession = () => {
  SessionManager.extendSession();
};

// Complete login flow
export const handleSuccessfulLogin = (userData, onLogin) => {
  console.log('✅ Login successful:', {
    username: userData.UserName,
    location: userData.UserLocation,
    hasToken: !!userData.token
  });

  setUserData(userData);
  
  // Setup axios headers for future API calls
  setupAxiosAuth(userData.token, userData.UserName);
  
  // Call the login callback
  onLogin(userData);
};

// Complete logout flow
export const handleLogout = (setUser, setShowQBAlert, setShowSessionWarning) => {
  clearUserData();
  clearAxiosAuth();
  
  // Reset UI state
  if (setUser) setUser(null);
  if (setShowQBAlert) setShowQBAlert(false);
  if (setShowSessionWarning) setShowSessionWarning(false);
  
  console.log('👋 User logged out successfully');
};

// Session expiry handler
export const handleSessionExpired = (setUser, setShowSessionWarning, onLogout) => {
  if (setShowSessionWarning) setShowSessionWarning(false);
  
  handleLogout(setUser, null, null);
  
  // Optionally show a message or call custom logout handler
  if (onLogout) {
    onLogout();
  } else {
    alert('Your session has expired. Please log in again.');
  }
  
  console.log('🚨 Session expired due to inactivity');
};

// Get auth headers for API calls
export const getAuthHeaders = () => {
  const userData = getUserData();
  const headers = {};
  
  if (userData?.token) {
    headers['Authorization'] = `Bearer ${userData.token}`;
  }
  
  if (userData?.UserName) {
    headers['X-Username'] = userData.UserName;
  }
  
  return headers;
};

// User role/permission checks (if you need them later)
export const getUserRole = () => {
  const userData = getUserData();
  return userData?.role || userData?.userRole || 'user';
};

export const getUserLocation = () => {
  const userData = getUserData();
  return userData?.UserLocation;
};

export const hasPermission = (permission) => {
  const userData = getUserData();
  const permissions = userData?.permissions || [];
  return permissions.includes(permission);
};

// Utility for protected routes
export const requireAuth = () => {
  if (!isAuthenticated()) {
    throw new Error('Authentication required');
  }
  return getUserData();
};